import { API_URL } from "../../config/connect";

const cache = new Map();

/**
 * Fetch regions from the Location API.
 * Cached at module level per countryId for the session — regions are
 * near-static, so repeated callers (favorites, adform, location modal, …)
 * share one in-flight request and get the resolved result instantly.
 * Cache resets only on failure so a retry is possible.
 * @param {number} countryId - Optional country ID to filter regions
 * @returns {Promise<Array>} Array of regions
 */
export async function getRegions(countryId = null) {
    const key = countryId ? String(countryId) : "all";

    const cached = cache.get(key);
    if (cached) return cached;

    const promise = (async () => {
        let endpoint = `${API_URL}/api/v1/regions`;
        if (countryId) {
            endpoint += `?country_id=${countryId}`;
        }

        const response = await fetch(endpoint, {
            method: 'GET',
            headers: {},
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.statusText}`);
        }

        const result = await response.json();
        return result.regions || [];
    })().catch((error) => {
        console.error('Failed to fetch regions:', error);
        cache.delete(key);
        throw error;
    });

    cache.set(key, promise);
    return promise;
}